<template>
    <el-dialog title="合同详情" :visible.sync="visible" width="1600px" top="5vh" :close-on-click-modal="false" :before-close="handleClose" custom-class="radius-dialog">
        <div slot="title" class="dialog-title">
            <h3>合同详情</h3><span>更新日期：{{ latestTime }}</span>
        </div>
        <div v-loading="loadAll">
            <div class="filters-container">
                <div class="filter-line">
                    <div class="title-name">学校名称：</div>
                    <div class="filter-ipt">
                        <el-input prefix-icon="el-icon-search" v-model="filters.schoolName" placeholder="搜索学校名称" class="no-border" @change="fetchData" clearable />
                    </div>
                </div>
                <div class="filter-line">
                    <div class="title-name">所在省份：</div>
                    <div class="filter-select">
                        <el-select v-model="filters.provinceId" placeholder="学校所在省份" filterable clearable @change="fetchData">
                            <el-option v-for="item in provinceOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </div>
                </div>
                <CheckedSelect v-model="filters.saleUserId" :options="mySaleUserOptions" label="销售人员" @change="fetchData" />
                <CheckedSelect v-model="filters.productId" :options="[{id:'',name:'全部'}, ...productList]" label="产品分类" @change="fetchData" />
                <div class="filter-line">
                    <div class="title-name">签署日期：</div>
                    <div class="filter-select">
                        <el-date-picker v-model="filters.signDate" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                            value-format="yyyy-MM-dd" @change="fetchData" />
                    </div>
                </div>
                <div style="display: flex;">
                    <CheckedSelect v-model="filters.contractType" :options="[{id:'',name:'全部'},{id:1,name:'新订'},{id:2,name:'续订'}]" label="合同类型" @change="fetchData"
                        style="margin-right: 112px;" />
                    <CheckedSelect v-model="filters.invoiceList" :options="[{id:'',name:'全部'},{id:1,name:'开票完成'},{id:0,name:'未开票'},{id:2,name:'部分开票'}]" label="合同开票"
                        :props="{multi:true}" @change="fetchData" />
                    <CheckedSelect v-model="filters.returnFlag" :options="[{id:'',name:'全部'},{id:1,name:'已返回'},{id:0,name:'未返回'}]" label="是否返回" @change="fetchData"
                        style="margin-left: 112px;" />
                </div>
                <div class="red-text" v-if="totalCount"><i class="el-icon-warning-outline"></i>
                    <span class="text" v-html="total_describe"></span>
                </div>
                <div class="export-box">
                    <el-button type="primary" icon="el-icon-download" :loading="loadExport" @click="exportData">导出列表</el-button>
                </div>
            </div>
            <el-table :data="tableData.slice((pageNum - 1) * pageSize, pageNum * pageSize)" row-key="contractId" @sort-change="tableSortChange"
                :header-cell-style="{'background-color': '#F2F3F5', 'color': '#333' }">
                <el-table-column label="序号" width="60" align="center">
                    <template slot-scope="{$index}">{{ $index + 1 + (pageNum - 1) * pageSize }}</template>
                </el-table-column>
                <el-table-column prop="schoolName" label="学校" width="140" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="productName" label="产品" min-width="150" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="saleUserName" label="签署人" min-width="80" align="left"></el-table-column>
                <el-table-column prop="signDate" label="签署日期" width="110" align="left" sortable="custom"></el-table-column>
                <el-table-column prop="type" label="合同类型" width="80" align="left">
                    <template slot-scope="{row}">
                        <div v-if="row.type === 1">新订</div>
                        <div v-else-if="row.type === 2">续订</div>
                    </template>
                </el-table-column>
                <el-table-column prop="returnFlag" label="是否返回" width="90" align="left">
                    <template slot-scope="{row}">
                        <i v-if="row.returnFlag == 1" class="el-icon-circle-check iconVerti" style="color: #56b562;"></i>
                        <i v-else class="el-icon-circle-close iconVerti" style="color: #f56c6c;"></i>
                        <span v-if="row.returnFlag === 1">已返回</span>
                        <span v-else>未返回</span>
                    </template>
                </el-table-column>
                <el-table-column prop="startDate" label="合同期限" width="270" align="left">
                    <template slot-scope="{row}">{{ row.startDate }}~{{ row.endDate }} ({{ row.days }}天)
                    </template>
                </el-table-column>
                <el-table-column prop="price" label="合同金额(元)" width="110" align="left">
                    <template slot-scope="{row}">￥{{ row.price }}</template>
                </el-table-column>
                <el-table-column prop="payTime" label="开票次数" width="80" align="left"></el-table-column>
                <el-table-column prop="payPrice" label="已开票金额(元)" width="120" align="left">
                    <template slot-scope="{row}">￥{{ row.payPrice }}</template>
                </el-table-column>
                <el-table-column prop="notInvoicePrice" label="未开票金额(元)" width="120" align="left">
                    <template #header>
                        <span style="color: #f53f3f">未开票金额(元)</span>
                    </template>
                    <template slot-scope="{row}">
                        <span :style="{'color': row.notInvoicePrice > 0 ? '#f53f3f' : '#606266'}">￥{{ row.notInvoicePrice }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="receivePrice" label="实际到账金额(元)" width="130" align="left">
                    <template slot-scope="{row}">￥{{ row.receivePrice }}</template>
                </el-table-column>
                <el-table-column prop="invoiceRemark" label="备注" min-width="250" align="left" show-overflow-tooltip></el-table-column>
            </el-table>
            <pagination v-show="totalCount" :total="tableData.length" :page.sync="pageNum" :limit.sync="pageSize" :pageSizes="[10, 20, 40, 50]"
                style="margin-top: 20px;" />
        </div>
    </el-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { findContractList, downloadContractList } from '@/api/statistics/index.js';

export default {
    name: 'covenantDetail',
    props: {
        visible: Boolean, // 弹窗显示/隐藏
        params: Object, // 总览统计的参数
        latestTime: String, // 数据最新更新时间
    },
    watch: {
        visible(val) {
            if (val) {
                this.pageNum = 1;
                this.pageSize = 10;
                this.filters.schoolName = ''
                this.filters.provinceId = ''
                this.filters.saleUserId = this.params.saleUserId;
                this.filters.productId = this.params.productId;
                this.filters.signDate = [];
                this.filters.contractType = this.params.contractType;
                this.filters.invoiceList = this.params.invoiceList
                // 处理日期格式为'yyyy-MM-dd'
                let { year, month, signDate } = this.params;
                if (signDate) {
                    this.filters.signDate = signDate;
                } else if (year && !month) {
                    // 有年没有月，开始为1月1日，结束为12月31日
                    this.filters.signDate[0] = `${year}-01-01`;
                    this.filters.signDate[1] = `${year}-12-31`;
                } else if (year && month) {
                    // 有年有月，开始为月的1日，结束为月的最后一天
                    this.filters.signDate[0] = this.$utils.formatDate(new Date(year, month - 1, 1), 'yyyy-MM-dd');
                    this.filters.signDate[1] = this.$utils.formatDate(new Date(year, month, 0), 'yyyy-MM-dd');
                }

                this.fetchData();
            }
        }
    },
    data() {
        return {
            loadAll: false,
            filters: {
                schoolName: '',
                provinceId: '',
                saleUserId: '',
                productId: '',
                signDate: [],
                contractType: '',
                invoiceList: [],
                returnFlag: ''
            },
            // 分页
            pageNum: 1,
            pageSize: 10,
            // 总结文字
            total_describe: '',
            // 表格数据
            tableData: [],
            totalCount: 0,
            // 导出
            loadExport: false,
        }
    },
    computed: {
        ...mapState(["productList", "mySaleUserOptions", "provinceOptions"]),
    },
    methods: {
        // 获取数据
        fetchData() {
            this.loadAll = true;
            let params = {
                ...this.filters,
                signDateStart: this.filters.signDate ? this.filters.signDate[0] : '',
                signDateEnd: this.filters.signDate ? this.filters.signDate[1] : ''
            }
            delete params.signDate
            findContractList(params).then(res => {
                this.totalCount = res.data.contractModelList.length;
                // 总结文字
                let { year, customerCount, totalPrice, invoicePrice, notInvoicePrice, receivePrice } = res.data
                this.total_describe = `根据筛选条件，${year ? `<b>${year}</b>年` : ''}${this.filters.month ? `<b>${this.filters.month}</b>月` : ''}`
                this.total_describe += `共找到<b>${customerCount}</b>个客户，签订合同<b>${this.totalCount}</b>份，合同总金额<b>${totalPrice}</b>万元，已开票金额<b>${invoicePrice}</b>万元，未开票金额<b>${notInvoicePrice}</b>万元，实际到账金额<b>${receivePrice}</b>万元。`
                // 表格数据
                this.tableData = res.data.contractModelList.map((item, index) => {
                    return {
                        ...item,
                        sort: index,
                        productName: item.productList.map(x => x.name)?.join('、') ?? '',
                    }
                })
                this.loadAll = false;
            }).catch(err => {
                if (err.status === 888) return;
                this.tableData = [];
                this.totalCount = 0;
                this.totalPrice = 0;
                this.invoicePrice = 0;
                this.notInvoicePrice = 0;
                this.receivePrice = 0;
                this.loadAll = false;
                this.$MessageBox.MessageWarning(err.data.msg);
            })
        },
        // 表格排序
        tableSortChange({ prop, order }) {
            if (order == "ascending") {
                // 升序
                if (prop === 'signDate') {
                    this.tableData.sort((a, b) => new Date(a[prop]) - new Date(b[prop]));
                } else {
                    this.tableData.sort((a, b) => a[prop] - b[prop]);
                }
            } else if (order == "descending") {
                // 降序
                if (prop === 'signDate') {
                    this.tableData.sort((a, b) => new Date(b[prop]) - new Date(a[prop]));
                } else {
                    this.tableData.sort((a, b) => b[prop] - a[prop]);
                }
            } else {
                this.tableData.sort((a, b) => a.sort - b.sort);
            }
            this.pageNum = 1;
        },
        // 关闭弹窗
        handleClose() {
            this.$emit("update:visible", false);
        },
        // 点击导出
        exportData() {
            this.loadExport = true;
            let params = {
                ...this.filters,
                signDateStart: this.filters.signDate ? this.filters.signDate[0] : '',
                signDateEnd: this.filters.signDate ? this.filters.signDate[1] : ''
            }
            delete params.signDate
            downloadContractList(params).then(res => {
                // 处理blob
                if (res.data.type === "application/json") {
                    let blobReader = new Response(res.data).json();
                    blobReader.then((item) => {
                        this.$MessageBox.MessageWarning(item.msg);
                        this.loadExport = false;
                    });
                } else {
                    // 成功，预览/下载报告
                    this.$utils.download(res);
                    this.loadExport = false;
                }
            }).catch(() => {
                this.loadExport = false;
            })
        },
    }
}
</script>

<style lang="scss" scoped>
/deep/ .radius-dialog {
    background-image: url("~@/assets/image/statistics/dialog-bg.png");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 12px;
    .el-dialog__body {
        padding: 15px 30px 30px 30px;
    }
    .el-dialog__header {
        padding-left: 30px;
        padding-right: 30px;
        .el-dialog__title {
            font-weight: 600;
        }
    }
    .dialog-title {
        h3 {
            display: inline-block;
            margin-right: 12px;
        }
        span {
            color: #7c7c7c;
            font-size: 14px;
        }
    }
}
.filters-container {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    margin-bottom: 20px;
    border-radius: 10px;
    /deep/ .filter-line {
        display: flex;
        &:not(:last-of-type) {
            margin-bottom: 8px;
        }
        .title {
            min-width: 5rem;
            padding-top: 7px;
            color: $primary-font-color;
        }
        .title-name {
            min-width: 5rem;
            padding-top: 7px;
            color: $primary-font-color;
            white-space: nowrap;
        }
        .filter-ipt {
            width: 40%;
            border-radius: 1.6rem;
            box-shadow: 0 0.06667rem 0.4rem 0.06667rem rgba(0, 0, 0, 0.1);
            overflow: hidden;
            padding: 0 0.6rem;
            > .el-input {
                .el-input__inner {
                    height: 2.2rem;
                    line-height: 2.2rem;
                }
                .el-input__icon {
                    line-height: 2.2rem;
                }
            }
        }
        .filter-select {
            height: 2.2rem;
            .el-input__inner {
                height: 2.2rem;
                line-height: 2.2rem;
                border-radius: 1.6rem;
                border: none;
                box-shadow: 0 0.06667rem 0.4rem 0.06667rem rgba(0, 0, 0, 0.1);
                .el-range__icon {
                    line-height: 30px;
                }
                .el-range-input {
                    font-size: 15px;
                }
                .el-range-separator {
                    width: 20px;
                    line-height: 30px;
                }
            }
            .el-input__suffix {
                right: 0.5rem;
                .el-input__icon {
                    line-height: 2.2rem;
                }
            }
        }
    }
    .export-box {
        position: absolute;
        bottom: 10px;
        right: 20px;
        > .el-button {
            border-radius: 0.8rem;
        }
    }
}
.red-text {
    color: #f53f3f;
    i {
        margin-right: 2px;
        font-size: 18px;
        font-weight: 600;
        vertical-align: -1px;
    }
    /deep/ .text b {
        margin: 0 2px;
    }
}
.iconVerti {
    margin-right: 3px;
    vertical-align: -1px;
    font-weight: 600;
    font-size: 1rem;
}
</style>